import { render, staticRenderFns } from "./EditarDadosProfissional.vue?vue&type=template&id=dd6e85a4"
import script from "./EditarDadosProfissional.vue?vue&type=script&lang=js"
export * from "./EditarDadosProfissional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports